import React from "react";

const EndBar = () => {
  return <div className="endbar">Schuyler McClean 2025</div>;
};

export default EndBar;
